<template>
  <Overlay unique-key="KetchModal" modal-width="WIDE">
    <div class="text-center">
      <p>
        This feature is disabled because you haven't consented to non-essential cookies.
        <BaseButton class="mt-8" label="Consent" to="KETCH" size="SMALL">Update Preferences</BaseButton>
      </p>
    </div>
  </Overlay>
</template>
